// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G2Y1","index":"styles_index__2p8C1"};